export const ServiceHost = 'https://service.commtlunk.com/api'